/**
 * Hook to fetch the ongoing RAG ingest job (if any) for the given org/user.
 * Mirrors useSecurityOngoingJob for job_type === 'ingest'.
 * Mount in a top-level component (MainLayout) so rehydration fires on any page.
 */

import { useQuery } from '@tanstack/react-query';
import { getOngoingIngestJob } from '@/services/security-scanner';

export const ingestOngoingJobKeys = {
  all: ['ingestOngoingJob'] as const,
  detail: (orgId: string | number, userId: string | number) =>
    [...ingestOngoingJobKeys.all, 'detail', orgId, userId] as const,
};

export interface UseIngestOngoingJobParams {
  org_id?: number | string;
  user_id?: number | string;
}

export function useIngestOngoingJob(params?: UseIngestOngoingJobParams) {
  return useQuery({
    queryKey: ingestOngoingJobKeys.detail(params?.org_id ?? '', params?.user_id ?? ''),
    queryFn: () =>
      getOngoingIngestJob({
        org_id: params!.org_id!,
        user_id: params!.user_id!,
      }),
    enabled: !!params?.org_id && !!params?.user_id,
    // Rehydration is a page-load operation — SSE handles live progress after that.
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
